<template>
  <div>
    <el-date-picker
      v-model="startTime"
      type="date"
      placeholder="开始日期"
      style="width: 200px"
      :picker-options="startTimePickerOptions"
      :value-format="valueFormat"
    />
    <span class="m-r-10 m-l-10">至</span>
    <el-date-picker
      v-model="endTime"
      type="date"
      placeholder="结束日期"
      style="width: 200px"
      :picker-options="endTimePickerOptions"
      :value-format="valueFormat"
    />
  </div>
</template>

<script>
import DateUtils from '@/utils/date'

export default {
  name: 'DateRangePicker',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Array,
      default: () => []
    },

    defaultTime: {
      type: Array,
      default: () => ['00:00:00', '23:59:59']
    },

    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    }
  },

  data() {
    return {
      startTimePickerOptions: {
        disabledDate: time => {
          return this.endTime
            ? time.getTime() >
                new Date(DateUtils.safeDate(this.endTime)).getTime()
            : false
        }
      },
      endTimePickerOptions: {
        disabledDate: time => {
          return this.startTime
            ? time.getTime() <
                new Date(DateUtils.safeDate(this.startTime)).getTime()
            : false
        }
      }
    }
  },

  computed: {
    startTime: {
      get() {
        return this.value[0]
      },
      set(val) {
        if (val) {
          const tempTimeList = val?.split(' ')
          tempTimeList[1] = this.defaultTime[0]
          this.$emit('change', [tempTimeList.join(' '), this.endTime])
        } else {
          this.$emit('change', ['', this.endTime])
        }
      }
    },
    endTime: {
      get() {
        return this.value[1]
      },
      set(val) {
        if (val) {
          const tempTimeList = val?.split(' ')
          tempTimeList[1] = this.defaultTime[1]
          this.$emit('change', [this.startTime, tempTimeList.join(' ')])
        } else {
          this.$emit('change', [this.startTime, ''])
        }
      }
    }
  }
}
</script>

<style scoped></style>
